import React from 'react';
import Styles from './ButtonCard.css';
import clsx from 'clsx';

/** @param {import('../../../../../types/SimuladorEnergiaSolar').ButtonCardProps} props */
function ButtonCard({ children, icon, text, selected, ...props }) {
  return (
    <>
      <button {...props} className={clsx('button-card', selected && 'selected', props.className)}>
        {icon && <img className="btn-icon" src={icon} alt="" />}
        {text && <span className="btn-text">{text}</span>}
        {children}
      </button>

      <style jsx>{Styles}</style>
    </>
  );
}

export default ButtonCard;
